// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"index_skeleton__d_a73","skeleton-loading":"index_skeleton-loading__26Hsv"};